/**
 * Detecta si el usuario tiene datos locales de vault dignos de conservar.
 *
 * En la Bóveda (zero-knowledge) "datos locales" significa: la raíz de cuenta
 * (`vault_account`, keyeada por `user_id`) o algún item en un vault propio
 * (`vault_item` cuelga de `vault.owner_user_id`). Es la señal que gobierna el
 * diálogo «¿conservar datos locales?» al migrar de invitado a cuenta real y el
 * botón «borrar datos locales» del perfil.
 *
 * NO consulta `ps_crud`: esa cola de subida contiene la fila de ajustes de
 * dispositivo que el arranque siembra para cada invitado (tablas `user`/`themes`,
 * que NO son datos a migrar) y dispararía el diálogo espuriamente.
 */
export const getHasLocalDataQuery = (userId: string) => {
  return {
    sql: `
    SELECT CASE
      WHEN EXISTS (SELECT id FROM vault_account WHERE user_id = ? LIMIT 1) THEN 1
      WHEN EXISTS (
        SELECT vault_item.id FROM vault_item
        JOIN vault ON vault.id = vault_item.vault_id
        WHERE vault.owner_user_id = ? LIMIT 1
      ) THEN 1
      ELSE 0
    END as hasData
  `,
    parameters: [userId, userId],
  };
};
